import { useEffect, useState } from "react"
import { faArrowRight, faBoltLightning, faDatabase, faGlobe, faShieldAlt } from "@fortawesome/free-solid-svg-icons"
import { Header } from "../../components/header/header"
import { ServiceHeader } from "../../components/services/service-header"
import { ServiceObject } from "../../components/services/services-obj"
import { MotionFrame } from "../../components/utilities/framer"
import { StackObject } from "../../components/services/tech-stack"
import { processes, techStacks } from "../../_helpers/mock-data"
import { GenLeft } from "../../components/utilities/service-framer"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Footer } from "../../components/footer/footer"
import { WebDevDialog } from "../../components/action-dialogs/web-actions"

export const WebDevelopMent = () => {

    const [showDialog, setShowDialog] = useState(false);

    const isOption = new URLSearchParams(window.location.search).get("options");

    useEffect(() => {
        isOption ?
        setShowDialog(true) :
        setShowDialog(false);
    }, [isOption]);

    return (
        <div className="rand-page">
            <Header pageTitle={"Web Development"} />
            <WebDevDialog 
                visible={showDialog} 
                toggleClose={() => setShowDialog((st) => !st)} 
            />
            <ServiceHeader
                gradText={"AI-Powered"}
                normText={"Web Development"}
                descr={"Transform your digital presence with intelligent web solutions that adapt, learn, and evolve with your business needs."}
                descrImg={"/images/web-development.jpeg"}
                fBtnCap={"Get Started"}
                sBtnCap={"View Portfolio"}
                fColor={"#1962c0ff"}
                sColor={"#152b87ff"}
                onStart={() => setShowDialog(true)}
                onNext={() => window.location.href = "/portfolio/websites"}
            />
            <MotionFrame>
                <div className="page-sub-cap">
                    <span className="norm-text">Intelligent</span>
                    <span className="gradient-text">Web Solutions</span>
                </div>
                <div className="descr flx-rw-c">
                    Our AI-assisted approach delivers web applications that are not just functional, but truly intelligent
                </div>
            </MotionFrame>
            <div className="services-box">
                <ServiceObject
                    topic={"Responsive Design"}
                    textDesc={"AI-optimized layouts that adapt perfectly to any device or screen size"}
                    icon={faGlobe}
                />
                <ServiceObject
                    topic={"Lightning Performance"}
                    textDesc={"Machine learning algorithms optimize loading speeds and user experience"}
                    icon={faBoltLightning}
                />
                <ServiceObject
                    topic={"Smart Database"}
                    textDesc={"Intelligent data management with AI-powered analytics and insights"}
                    icon={faDatabase}
                />

                <ServiceObject
                    topic={"Advanced Security"}
                    textDesc={"AI-driven security protocols protect against emerging cyber threats"}
                    icon={faShieldAlt}
                />
            </div>

            <MotionFrame>
                <div className="page-sub-cap">
                    <span className="norm-text">Cutting-Edge</span>
                    <span className="gradient-text">Technologies</span>
                </div>
                <div className="descr flx-rw-c">
                    We leverage the latest technologies enhanced with AI capabilities
                </div>
            </MotionFrame>

            <div className="services-box">
                {techStacks.map((stack, k) => (
                    <StackObject stack={stack} key={k} />
                ))}
            </div>

            <MotionFrame>
                <div className="page-sub-cap">
                    <span className="norm-text">Our</span>
                    <span className="gradient-text">Development Process</span>
                </div>
            </MotionFrame>

            <div className="services-box">
                {processes.map((process, indx) => (
                    <GenLeft key={indx}>
                        <div className="process-unit">
                            <div className="num-circle">0{indx + 1}</div>
                            <div className="process-caption">{process.caption}</div>
                            <div className="process-descr">{process.descr}</div>
                        </div>
                    </GenLeft>
                ))}
            </div>
            <GenLeft>
                <div className="offer-bx glassy-effect">
                    <div className="q-cap">
                        <span className="norm-text of-cap">Ready to Build Something</span>
                        <span className="gradient-text of-cap"> Amazing</span>
                        <span className="norm-text of-cap">?</span>
                    </div>
                    <div className="descr">
                        Let's create an intelligent web solution that grows with your business
                    </div>
                    <div className="bttn">
                        <button className="of-btn bl-btn">
                            <span className="of-btn-txt">Start Your Project</span>
                            <FontAwesomeIcon icon={faArrowRight} />
                        </button>
                    </div>
                    
                </div>
            </GenLeft>
            <Footer />
        </div>
    )
}